import React, { useState, useEffect } from 'react';
import AppFooter from '../AppLayout/components/AppFooter';
import AppErrorBoundary from '../AppErrorBoundary';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import AppContentViewWrapper from './AppContentViewWrapper';
import AppSuspense from '../AppSuspense';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import BottomNavigationBar from '../AppLayout/HorDefault/BottomNavigationBar';
import { Capacitor } from '@capacitor/core';

const AppContentView = ({ sxStyle, routes, settings }) => {
  const { isMobile } = useMobileSettings();
  const { user } = useAuthUser();
  const [isNavCollapsed, setIsNavCollapsed] = useState(false);
  const { pathname } = useLocation();

  const iOS = Capacitor.getPlatform() === 'ios';
  const android = Capacitor.getPlatform() === 'android';

  const toggleNavCollapsed = () => {
    setIsNavCollapsed(!isNavCollapsed);
  };

  useEffect(() => {
    if (isNavCollapsed) setIsNavCollapsed(false);
  }, [pathname]);

  const allowedRoutes = [
    `/${user?.roleMenuFlag[0]}/product-listing`,
    `/${user?.roleMenuFlag[0]}/basic-calendar`,
    `/${user?.roleMenuFlag[0]}/events`,
    `/${user?.roleMenuFlag[0]}/settingsTab`,
    `/dashboard`,
  ];

  const showBottomBar =
    user &&
    allowedRoutes.some((route) => pathname.includes(route)) &&
    !pathname.includes('/student/waiver');

  let contentClass = 'app-content';
  if (iOS) {
    contentClass = 'ios-App-content';
  } else if (android) {
    contentClass = 'App-content';
  }

  return (
    <>
      <AppContentViewWrapper>
        <Box
          sx={{
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            p: { xs: 5, md: 7.5, xl: 12.5 },
            ...sxStyle,
          }}
          className={contentClass}
        >
          <AppSuspense>
            {/* ✅ This resets the error boundary automatically when route changes */}
            <AppErrorBoundary key={pathname}>{routes}</AppErrorBoundary>
          </AppSuspense>
        </Box>
      </AppContentViewWrapper>

      {isMobile
        ? showBottomBar && (
            <BottomNavigationBar
              isNavCollapsed={isNavCollapsed}
              toggleNavCollapsed={toggleNavCollapsed}
            />
          )
        : settings && (
            <AppFooter
              customer={settings.customer}
              socialSettings={settings.social}
            />
          )}
    </>
  );
};

AppContentView.propTypes = {
  sxStyle: PropTypes.object,
  settings: PropTypes.object,
  routes: PropTypes.object.isRequired,
};

export default AppContentView;
